import { useEffect, useState } from 'react'
import { useImmer } from 'use-immer'
import { useDispatch } from "react-redux"
import { setAdditionalSubHdView, setSubHeading } from "../../store/reducers/CommonReducer"
import { setContentLoading } from "../../store/reducers/CommonReducer"
import { CC_PRODUCT_ID, TOKEN_2 } from "../../utils/Constants"
import { getSessionItem } from "../../utils/storageUtils"
import { SIP_URL } from "../../utils/Config"
import { getHTMLObject, getTranslated } from "../../utils/CommonUtils"
import { useSelector } from "react-redux"
import { Divider, Select, Button } from 'antd'
import UMCButton from '../common/UMCButton'
import { DARK_GRAY, PURPLE, } from "../../styles/styleUtils"
import InputField from "./InputField"
import TabExtraContent from '../common/TabExtraContent'
import parse from 'html-react-parser'
import CustomDialog from './CustomDialog'
import getData from './GetData'

//===================================
// VAA gateway parameters config page
//===================================

const VAAGateway = ({ onPrevious, onNext, activeProfile, trunkConfig, setTrunkConfig, configurationData, setConfigurationData }) => {
    const [errorsOnPage, setErrorsOnPage] = useState(0);

    const [workingSipTrunkConfig, setWorkingSipTrunkConfig] = useImmer({});

    // Dialog parameters
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [dlgType, setDlgType] = useState();
    const [title, setTitle] = useState();
    const [message, setMessage] = useState();
    // Dialog footer button definition
    const [footer, setFooter] = useState([]);

    const dispatch = useDispatch();
    const dict = useSelector((state) => state.common.dict);
    const language = useSelector((state) => state.common.language);
    
    let errorsOnRedraw = errorsOnPage;

    const profileHandler = (data) => {
        setConfigurationData(data[0]);
    }

    useEffect(() => {
        dispatch(setSubHeading(getTranslated(dict, "LABEL_CREATE_SIP_TRUNK") + " : " + activeProfile.name));
    }, [dict]);

    useEffect(() => {
        dispatch(setAdditionalSubHdView(getExtraSubHeaderContent()));

        const fetchData = async () => {
            var url, response;

            try {
                url = SIP_URL + "/sipprofile/params/" + activeProfile.id;

                dispatch(setContentLoading(true));
                response = await getData(url, null, profileHandler);
                dispatch(setContentLoading(false));
            }
            catch (e) {
                console.error(e);
                dispatch(setContentLoading(false));
            }
        };

        if (trunkConfig?.Profile !== undefined) {
            setWorkingSipTrunkConfig(trunkConfig);
        } else {
            fetchData();
        }
    }, []);

    // VAA SIP Trunk data handlers
    const updateTrunkGroupName = (value) => {
        setWorkingSipTrunkConfig(draft => { draft.Profile.UI_VAA_Ext_Gateway_Data.SIP_Outbound_Proxy_User = value; });
    }

    const updateFQDN = (value) => {
        setWorkingSipTrunkConfig(draft => { draft.Profile.UI_VAA_Ext_Gateway_Data.UMC_FQDN_Or_IP_Address = value; });
    }

    const updateIncomingUsername = (value) => {
        setWorkingSipTrunkConfig(draft => { draft.Profile.UI_VAA_Ext_Gateway_Data.SIP_Incoming_Username = value; });
    }

    const updateIncomingPassword = (value) => {
        setWorkingSipTrunkConfig(draft => { draft.Profile.UI_VAA_Ext_Gateway_Data.SIP_Incoming_Password = value; });
    }

    // VAA SIP MASTER Trunk data handlers
    const updateMasterTrunkGroupName = (value) => {
        setWorkingSipTrunkConfig(draft => { draft.Profile.UI_VAA_Master_Ext_Gateway_Data.SIP_Outbound_Proxy_User = value; });
    }

    const updateMasterFQDN = (value) => {
        setWorkingSipTrunkConfig(draft => { draft.Profile.UI_VAA_Master_Ext_Gateway_Data.UMC_FQDN_Or_IP_Address = value; });
    }

    const updateMasterIncomingUsername = (value) => {
        setWorkingSipTrunkConfig(draft => { draft.Profile.UI_VAA_Master_Ext_Gateway_Data.SIP_Incoming_Username = value; });
    }

    const updateMasterIncomingPassword = (value) => {
        setWorkingSipTrunkConfig(draft => { draft.Profile.UI_VAA_Master_Ext_Gateway_Data.SIP_Incoming_Password = value; });
    }

    // VAA SIP MASTER Trunk data handlers
    const updateSlaveTrunkGroupName = (value) => {
        setWorkingSipTrunkConfig(draft => { draft.Profile.UI_VAA_Slave_Ext_Gateway_Data.SIP_Outbound_Proxy_User = value; });
    }

    const updateSlaveFQDN = (value) => {
        setWorkingSipTrunkConfig(draft => { draft.Profile.UI_VAA_Slave_Ext_Gateway_Data.UMC_FQDN_Or_IP_Address = value; });
    }

    const updateSlaveIncomingUsername = (value) => {
        setWorkingSipTrunkConfig(draft => { draft.Profile.UI_VAA_Slave_Ext_Gateway_Data.SIP_Incoming_Username = value; });
    }

    const updateSlaveIncomingPassword = (value) => {
        setWorkingSipTrunkConfig(draft => { draft.Profile.UI_VAA_Slave_Ext_Gateway_Data.SIP_Incoming_Password = value; });
    }

    // Error handler (count errors on the page)
    const errorHandler = (value) => {

        if (value === true) {
            errorsOnRedraw++;
        }
        else {
            if (errorsOnPage > 0)
                errorsOnRedraw--;
        }
        setErrorsOnPage(errorsOnRedraw);
    }

    // Create JSON config for SIPtrunk
    function createTrunkConfig() {
        let obj = { Profile: {} };
        Object.keys(configurationData.Profile).forEach(group => {
            obj.Profile[group] = {};
            Object.keys(configurationData.Profile[group]).forEach(key => {
                if (configurationData.Profile[group][key]?.defaultValue !== undefined) {
                    obj.Profile[group][key] = configurationData.Profile[group][key].defaultValue;
                }
                else {
                    var value = configurationData.Profile[group][key];

                    if (Array.isArray(value)) {
                        obj.Profile[group][key] = [];
                    } 
                    else if (typeof value === 'object' && value !== null) {
                        obj.Profile[group][key] = {}; 
                        Object.keys(value).forEach(subKey => {
                            obj.Profile[group][key][subKey] = value[subKey].defaultValue;
                        })
                    }
                }
            })
        });
        return obj;
    }

    // Modal message handlers
    const showModal = () => {
        setIsModalOpen(true);
    };

    const handleOk = () => {
        setIsModalOpen(false);
    };

    const handleCancel = () => {
        setIsModalOpen(false);
    };

    // Previous button handler. The previous page is the profile selection so we have to erase the trunk config
    const onPreviousPage = () => {
        setTrunkConfig({});
        onPrevious();
    }

    // Validation handler for the page
    async function validateFields() {
        if (workingSipTrunkConfig?.Profile?.UI_VAA_Master_Ext_Gateway_Data?.SIP_Outbound_Proxy_User && workingSipTrunkConfig?.Profile?.UI_VAA_Slave_Ext_Gateway_Data?.SIP_Outbound_Proxy_User) {
            if (workingSipTrunkConfig?.Profile?.UI_VAA_Master_Ext_Gateway_Data?.SIP_Outbound_Proxy_User === workingSipTrunkConfig?.Profile?.UI_VAA_Slave_Ext_Gateway_Data?.SIP_Outbound_Proxy_User) {
                setDlgType("Error");
                setTitle(getTranslated(dict, "LABEL_SIP_TRUNK_CREATION_IMPOSSIBLE"));
                setMessage(getTranslated(dict, "MSG_SAME_TRUNK_NAME"));
                setFooter([
                    <Button key="ok" type="primary" onClick={handleOk} className="sip-modal-btn">
                        {getTranslated(dict, "LABEL_OK")}
                    </Button>,
                ]);
                errorsOnRedraw++;
                showModal(true);
            }
        }

        // Update the parent state
        setTrunkConfig(workingSipTrunkConfig);

        if (errorsOnRedraw === 0) {
            onNext();
        }
    }

    // Top right icons 
    const getExtraSubHeaderContent = () => {
        return <TabExtraContent
            contentItems={activeProfile.docRef ? ["document", "help"] : ["help"]}
            documentButtonText={activeProfile.docRef}
            handleDocument={() => {
                if (activeProfile.docUrl !== "")
                    window.open(`${activeProfile.docUrl}`, "_blank")
            }}
            handleHelpReq={() => {
                // code to handle help doc action
                let src = `/hol/oxe/oxe-${'en' || language}/dita/topics/umc_EN_DE_ES_FR/umc_easy-sip-trunk-creation.html`
                window.open(`${src}#Create-VAA__SIP-Parameters`, "_blank")
            }}
        />
    }

    if (configurationData?.Profile !== undefined && workingSipTrunkConfig?.Profile === undefined) {
        setWorkingSipTrunkConfig(createTrunkConfig());
    }

    return (<>
        {(() => {
            if (configurationData?.Profile?.UI_VAA_Ext_Gateway_Data !== undefined) {
                return (<div>
                    <Divider className="sip-header" orientation="left" orientationMargin="0" plain style={{ borderColor: DARK_GRAY, }}>
                        {getTranslated(dict, "LABEL_UI_VAA_EXT_GATEWAY_DATA")}
                    </Divider>

                    { // Gateway name
                        configurationData?.Profile?.UI_VAA_Ext_Gateway_Data?.SIP_Outbound_Proxy_User &&
                        <InputField label={getTranslated(dict, "PARAM_VAA_TRUNK_GROUP_NAME")}
                            defaultValue={configurationData?.Profile?.UI_VAA_Ext_Gateway_Data?.SIP_Outbound_Proxy_User?.defaultValue}
                            regexp={configurationData?.Profile?.UI_VAA_Ext_Gateway_Data?.SIP_Outbound_Proxy_User?.pattern}
                            handleChange={updateTrunkGroupName}
                            handleError={errorHandler}
                            value={trunkConfig?.Profile?.UI_VAA_Ext_Gateway_Data?.SIP_Outbound_Proxy_User} />
                    }

                    { // FQDN or IP
                        configurationData.Profile?.UI_VAA_Ext_Gateway_Data?.UMC_FQDN_Or_IP_Address &&
                        <InputField label={getTranslated(dict, "PARAM_VAA_FQDN")}
                            defaultValue={configurationData.Profile?.UI_VAA_Ext_Gateway_Data?.UMC_FQDN_Or_IP_Address?.defaultValue}
                            regexp={configurationData.Profile?.UI_VAA_Ext_Gateway_Data?.UMC_FQDN_Or_IP_Address?.pattern}
                            handleChange={updateFQDN}
                            handleError={errorHandler}
                            validationPattern="Domain"
                            value={trunkConfig?.Profile?.UI_VAA_Ext_Gateway_Data?.UMC_FQDN_Or_IP_Address} />
                    }

                    { // Incoming username
                        configurationData?.Profile?.UI_VAA_Ext_Gateway_Data?.SIP_Incoming_Username &&
                        <InputField label={getTranslated(dict, "PARAM_VAA_INCOMING_USERNAME")}
                            defaultValue={configurationData?.Profile?.UI_VAA_Ext_Gateway_Data?.SIP_Incoming_Username?.defaultValue}
                            regexp={configurationData?.Profile?.UI_VAA_Ext_Gateway_Data?.SIP_Incoming_Username?.pattern}
                            handleChange={updateIncomingUsername}
                            handleError={errorHandler}
                            value={trunkConfig?.Profile?.UI_VAA_Ext_Gateway_Data?.SIP_Incoming_Username} />
                    }

                    { // Incoming password
                        configurationData?.Profile?.UI_VAA_Ext_Gateway_Data?.SIP_Incoming_Password &&
                        <InputField label={getTranslated(dict, "PARAM_VAA_INCOMING_PASSWORD")}
                            defaultValue={configurationData?.Profile?.UI_VAA_Ext_Gateway_Data?.SIP_Incoming_Password?.defaultValue}
                            regexp={configurationData?.Profile?.UI_VAA_Ext_Gateway_Data?.SIP_Incoming_Password?.pattern}
                            handleChange={updateIncomingPassword}
                            handleError={errorHandler}
                            contentDisplay={configurationData?.Profile?.UI_VAA_Ext_Gateway_Data?.SIP_Incoming_Password?.echo}
                            value={trunkConfig?.Profile?.UI_VAA_Ext_Gateway_Data?.SIP_Incoming_Password} />
                    }
                </div>)
            }
        })()
        }

        {(() => {
            if (configurationData?.Profile?.UI_VAA_Master_Ext_Gateway_Data !== undefined) {
                return (<div>
                    <Divider className="sip-header" orientation="left" orientationMargin="0" plain style={{ borderColor: DARK_GRAY, }}>
                        {getTranslated(dict, "LABEL_UI_VAA_MASTER_EXT_GATEWAY_DATA")}
                    </Divider>

                    { // Gateway name
                        configurationData?.Profile?.UI_VAA_Master_Ext_Gateway_Data?.SIP_Outbound_Proxy_User &&
                        <InputField label={getTranslated(dict, "PARAM_VAA_TRUNK_GROUP_NAME")}
                            defaultValue={configurationData?.Profile?.UI_VAA_Master_Ext_Gateway_Data?.SIP_Outbound_Proxy_User?.defaultValue}
                            regexp={configurationData?.Profile?.UI_VAA_Master_Ext_Gateway_Data?.SIP_Outbound_Proxy_User?.pattern}
                            handleChange={updateMasterTrunkGroupName}
                            handleError={errorHandler}
                            value={trunkConfig?.Profile?.UI_VAA_Master_Ext_Gateway_Data?.SIP_Outbound_Proxy_User} />
                    }

                    { // FQDN or IP
                        configurationData.Profile?.UI_VAA_Master_Ext_Gateway_Data?.UMC_FQDN_Or_IP_Address &&
                        <InputField label={getTranslated(dict, "PARAM_VAA_FQDN")}
                            defaultValue={configurationData.Profile?.UI_VAA_Master_Ext_Gateway_Data?.UMC_FQDN_Or_IP_Address?.defaultValue}
                            regexp={configurationData.Profile?.UI_VAA_Master_Ext_Gateway_Data?.UMC_FQDN_Or_IP_Address?.pattern}
                            handleChange={updateMasterFQDN}
                            handleError={errorHandler}
                            validationPattern="Domain"
                            value={trunkConfig?.Profile?.UI_VAA_Master_Ext_Gateway_Data?.UMC_FQDN_Or_IP_Address} />
                    }

                    { // Incoming username
                        configurationData?.Profile?.UI_VAA_Master_Ext_Gateway_Data?.SIP_Incoming_Username &&
                        <InputField label={getTranslated(dict, "PARAM_VAA_INCOMING_USERNAME")}
                            defaultValue={configurationData?.Profile?.UI_VAA_Master_Ext_Gateway_Data?.SIP_Incoming_Username?.defaultValue}
                            regexp={configurationData?.Profile?.UI_VAA_Master_Ext_Gateway_Data?.SIP_Incoming_Username?.pattern}
                            handleChange={updateMasterIncomingUsername}
                            handleError={errorHandler}
                            value={trunkConfig?.Profile?.UI_VAA_Master_Ext_Gateway_Data?.SIP_Incoming_Username} />
                    }

                    { // Incoming password
                        configurationData?.Profile?.UI_VAA_Master_Ext_Gateway_Data?.SIP_Incoming_Password &&
                        <InputField label={getTranslated(dict, "PARAM_VAA_INCOMING_PASSWORD")}
                            defaultValue={configurationData?.Profile?.UI_VAA_Master_Ext_Gateway_Data?.SIP_Incoming_Password?.defaultValue}
                            regexp={configurationData?.Profile?.UI_VAA_Master_Ext_Gateway_Data?.SIP_Incoming_Password?.pattern}
                            handleChange={updateMasterIncomingPassword}
                            handleError={errorHandler}
                            contentDisplay={configurationData?.Profile?.UI_VAA_Master_Ext_Gateway_Data?.SIP_Incoming_Password?.echo}
                            value={trunkConfig?.Profile?.UI_VAA_Master_Ext_Gateway_Data?.SIP_Incoming_Password} />
                    }
                </div>)
            }
        })()
        }

        {(() => {
            if (configurationData?.Profile?.UI_VAA_Slave_Ext_Gateway_Data !== undefined) {
                return (<div>
                    <Divider className="sip-header" orientation="left" orientationMargin="0" plain style={{ borderColor: DARK_GRAY, }}>
                        {getTranslated(dict, "LABEL_UI_VAA_SLAVE_EXT_GATEWAY_DATA")}
                    </Divider>

                    { // Gateway name
                        configurationData?.Profile?.UI_VAA_Slave_Ext_Gateway_Data?.SIP_Outbound_Proxy_User &&
                        <InputField label={getTranslated(dict, "PARAM_VAA_TRUNK_GROUP_NAME")}
                            defaultValue={configurationData?.Profile?.UI_VAA_Slave_Ext_Gateway_Data?.SIP_Outbound_Proxy_User?.defaultValue}
                            regexp={configurationData?.Profile?.UI_VAA_Slave_Ext_Gateway_Data?.SIP_Outbound_Proxy_User?.pattern}
                            handleChange={updateSlaveTrunkGroupName}
                            handleError={errorHandler}
                            value={trunkConfig?.Profile?.UI_VAA_Slave_Ext_Gateway_Data?.SIP_Outbound_Proxy_User} />
                    }

                    { // FQDN or IP
                        configurationData.Profile?.UI_VAA_Slave_Ext_Gateway_Data?.UMC_FQDN_Or_IP_Address &&
                        <InputField label={getTranslated(dict, "PARAM_VAA_FQDN")}
                            defaultValue={configurationData.Profile?.UI_VAA_Slave_Ext_Gateway_Data?.UMC_FQDN_Or_IP_Address?.defaultValue}
                            regexp={configurationData.Profile?.UI_VAA_Slave_Ext_Gateway_Data?.UMC_FQDN_Or_IP_Address?.pattern}
                            handleChange={updateSlaveFQDN}
                            handleError={errorHandler}
                            validationPattern="Domain"
                            value={trunkConfig?.Profile?.UI_VAA_Slave_Ext_Gateway_Data?.UMC_FQDN_Or_IP_Address} />
                    }

                    { // Incoming username
                        configurationData?.Profile?.UI_VAA_Slave_Ext_Gateway_Data?.SIP_Incoming_Username &&
                        <InputField label={getTranslated(dict, "PARAM_VAA_INCOMING_USERNAME")}
                            defaultValue={configurationData?.Profile?.UI_VAA_Slave_Ext_Gateway_Data?.SIP_Incoming_Username?.defaultValue}
                            regexp={configurationData?.Profile?.UI_VAA_Slave_Ext_Gateway_Data?.SIP_Incoming_Username?.pattern}
                            handleChange={updateSlaveIncomingUsername}
                            handleError={errorHandler}
                            value={trunkConfig?.Profile?.UI_VAA_Slave_Ext_Gateway_Data?.SIP_Incoming_Username} />
                    }

                    { // Incoming password
                        configurationData?.Profile?.UI_VAA_Slave_Ext_Gateway_Data?.SIP_Incoming_Password &&
                        <InputField label={getTranslated(dict, "PARAM_VAA_INCOMING_PASSWORD")}
                            defaultValue={configurationData?.Profile?.UI_VAA_Slave_Ext_Gateway_Data?.SIP_Incoming_Password?.defaultValue}
                            regexp={configurationData?.Profile?.UI_VAA_Slave_Ext_Gateway_Data?.SIP_Incoming_Password?.pattern}
                            handleChange={updateSlaveIncomingPassword}
                            handleError={errorHandler}
                            contentDisplay={configurationData?.Profile?.UI_VAA_Slave_Ext_Gateway_Data?.SIP_Incoming_Password?.echo}
                            value={trunkConfig?.Profile?.UI_VAA_Slave_Ext_Gateway_Data?.SIP_Incoming_Password} />
                    }
                </div>)
            }
        })()
        }
        <div className="sip-nav-buttons profile-span">
            <UMCButton
                className="sip-navigation-button sip-navigation-back sip-btn-fontsize"
                label={getTranslated(dict, "LABEL_BACK")}
                type="primary"
                onClick={onPreviousPage}
                disabled={false} />
            <UMCButton
                className="sip-navigation-button sip-btn-fontsize"
                label={getTranslated(dict, "LABEL_NEXT")}
                type="primary"
                onClick={validateFields}
                disabled={errorsOnPage !== 0} />
        </div>
        <CustomDialog
            title={title}
            open={isModalOpen}
            width={dlgType === "Error" ? "400px" : "500px"}
            footer={footer}
            type={dlgType}
            onCancel={handleCancel}
        >
            {message}
        </CustomDialog>
    </>);
}

export default VAAGateway;